import {useReducer, useEffect} from "react"
import {EcpProjectsContext} from "../contexts/EcpProjectsContext"
import ecpProjectsReducer from "../reducers/ecpProjectsReducer"

const initialState = {
    isModal: false,
    isConfirmationModal: {
        modal: false,
        id: null,
        action: null
    },
    tab: "my-projects",
    page: 1,
    projectID: null,
}

export default function EcpProjectsProvider({children}) {
    const [ecpProjectsContext, setEcpProjectsAction] = useReducer(
        ecpProjectsReducer,
        initialState,
    )

    useEffect(() => {
        if (ecpProjectsContext) {
            localStorage.setItem("ecpProjectsContext", JSON.stringify(ecpProjectsContext))
        } else {
            localStorage.removeItem("ecpProjectsContext")
        }
    }, [ecpProjectsContext])

    return (
        <EcpProjectsContext.Provider value={{ecpProjectsContext, setEcpProjectsAction}}>
            {children}
        </EcpProjectsContext.Provider>
    )
}